import React from 'react';
import ScrollingBanner from './ScrollingBanner';
import {
  Container,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Button,
  Grid,
  IconButton,
  Box
} from '@mui/material';
import { Add, Remove, Delete } from '@mui/icons-material';
import { useCart } from '../context/CartContext';
import './CartAndCheckout.css';
import Navbar from './layout/Navbar'; 
import CheckoutForm from './CheckoutForm';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe('your-publishable-key-here');

const Cart = () => {
  const { cartItems, removeFromCart, updateQuantity } = useCart();

  console.log('cartItems:', cartItems);

  if (!cartItems) {
    return (
      <Container>
        <Navbar />
        <Typography variant="h5" align="center" sx={{ mt: 4 }}>
          Loading...
        </Typography>
      </Container>
    );
  }

  if (cartItems.length === 0) {
    return (
      <Container>
        <Navbar />
        <Typography variant="h5" align="center" sx={{ mt: 4 }}>
          Your cart is empty
        </Typography>
      </Container>
    );
  }

  const calculateTotal = () => {
    return cartItems.reduce((total, item) => total + item.salePrice * item.quantity, 0);
  };

  return (
    <div className="cart" style={{ backgroundColor: '#FFF8DC', minHeight: '100vh' }}>
      <ScrollingBanner />
      <Navbar />
      <Container>
        <Typography 
          variant="h4" 
          sx={{ 
            mb: 3, 
            color: '#FFFFFF',
            fontFamily: 'serif',
            textAlign: 'center',
            fontWeight: 'bold',
            textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
          }}
        >
          Shopping Cart
        </Typography>
        <Box display="flex" justifyContent="space-between">
          <Box sx={{ flex: 1, mr: 2 }}>
            <Box display="flex" flexDirection="column" spacing={1}>
              {cartItems.map((item) => (
                <Card key={item.id} sx={{ mb: 1, padding: '8px' }}>
                  <Box display="flex">
                    <Box sx={{ width: '100%', sm: '25%' }}>
                      <CardMedia
                        component="img"
                        height="100"
                        image={item.image}
                        alt={item.name}
                        sx={{ objectFit: 'scale-down' }}
                      />
                    </Box>
                    <Box sx={{ width: '100%', sm: '75%' }}>
                      <CardContent sx={{ padding: '4px' }}>
                        <Typography variant="h6" sx={{ fontSize: '1rem' }}>{item.name}</Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
                          Sale Price: ${item.salePrice.toFixed(2)}
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ textDecoration: 'line-through', fontSize: '0.875rem' }}>
                          Original Price: ${item.price.toFixed(2)}
                        </Typography>
                        <Box sx={{ mt: 1, display: 'flex', alignItems: 'center' }}>
                          <IconButton 
                            onClick={() => updateQuantity(item.id, Math.max(0, item.quantity - 1))}
                            size="small"
                          >
                            <Remove />
                          </IconButton>
                          <Typography sx={{ mx: 1 }}>{item.quantity}</Typography>
                          <IconButton 
                            onClick={() => updateQuantity(item.id, item.quantity + 1)}
                            size="small"
                          >
                            <Add />
                          </IconButton>
                          <IconButton 
                            onClick={() => removeFromCart(item.id)}
                            color="error"
                            sx={{ ml: 2 }}
                          >
                            <Delete />
                          </IconButton>
                        </Box>
                      </CardContent>
                    </Box>
                  </Box>
                </Card>
              ))}
            </Box>
          </Box>
        </Box>
        <Box sx={{ mt: 4, textAlign: 'right' }}>
          <Typography variant="h5">
            Total: ${calculateTotal().toFixed(2)}
          </Typography>
          <Elements stripe={stripePromise}>
            <CheckoutForm />
          </Elements>
        </Box>
      </Container>
    </div>
  );
};

export default Cart;
